

import Vue from 'vue'
import Component from "vue-class-component";
import {IOnOffHandlers} from "bonomo/dist";
import {namespace} from "vuex-class";
import CreateButton from "@/components/shared/CreateButton.vue";
import {IErrors} from "@/model/IErrors";
import {IZone} from "@/store/modules/settings/zonesModule";

const zonesModule = namespace("zonesModule");

@Component({
  components: {
    CreateButton,
  }
})
export default class Zones extends Vue {

  @zonesModule.Getter('zones')
  private zones!: IZone[];
  @zonesModule.Getter('errors')
  private errors!: IErrors;

  protected loading: boolean = true;
  protected showDialog: boolean = false;
  protected newNameZone: string = '';
  private subscribes: IOnOffHandlers = {};

  created() {
    this.subscribes = this.$ons({
      'login.OK': this.loadData,
      'backend.call.OK.zonesLoaded': this.onLoadedOK,
      'backend.call.KO.zonesLoaded': this.onLoadedKO,
    });
    this.loadData();
  }
  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  protected onCreate() {
    this.showDialog = true;
  }
  protected onSubmitDialog() {
    this.loading = true;
    this.$store.dispatch('zonesModule/createZone', {zone: this.newNameZone});
  }

  private loadData() {
    this.$store.dispatch('zonesModule/fetchZones');
  }
  private onLoadedOK() {
    this.newNameZone = '';
    this.loading = false;
    this.showDialog = false;
  }
  private onLoadedKO() {
    this.loading = false;
  }
}

